/**
 * Returns a slot decorator.
 *
 * @param { Slot } slotData
 * @returns { PropertyDecorator }
 */
const slot = (slotData) => {
    return (target, slotKey) => {
        const ctor = target.constructor;
        if (!Object.prototype.hasOwnProperty.call(ctor, "decoratorMetadata")) {
            ctor.decoratorMetadata = {};
        }
        const decoratorMetadata = ctor.decoratorMetadata;
        if (!decoratorMetadata.slots) {
            decoratorMetadata.slots = {};
        }
        const slotMetadata = decoratorMetadata.slots;
        if (slotData?.default && slotMetadata.default) {
            throw new Error("Only one slot can be the default slot.");
        }
        const key = slotData?.default ? "default" : slotKey;
        slotData = slotData || { type: HTMLElement };
        if (!slotData.type) {
            slotData.type = HTMLElement;
        }
        if (!slotMetadata[key]) {
            slotMetadata[key] = slotData;
        }
        if (slotData.default) {
            delete slotMetadata.default.default;
            slotMetadata.default.propertyName = slotKey;
        }
        ctor.decoratorMetadata.managedSlots = true;
    };
};
export default slot;
//# sourceMappingURL=slot.js.map